<template>
  <v-layout>
    <v-card class="bordered-card" style="width: 100%;">
      <v-toolbar class="grey lighten-4 elevation-0">
        <v-toolbar-title class="grey--text text-underline text--darken-4">
          Manange Tutorials
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs4>
          <v-btn @click.prevent="goto('/admin/settings/tutorials/tutorial-new')">
            <v-icon>add</v-icon>
            Add new
          </v-btn>
        </v-flex>
      </v-card-title>
      <v-data-table hide-actions ref="faqTable" :headers="headers" :items="tutorials" :rows-per-page-items="[100]">
        <template slot="items" slot-scope="props">
          <tr class="sortableRow" :key="props.item.id">
            <td class="text-xs-left" style="width: 0.1%">
              <v-tooltip top>
                <v-btn slot="activator" style="cursor: move" icon class="sortHandle"><v-icon>drag_handle</v-icon></v-btn>
                <span>Click and drag to reorder</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">{{ props.item.question }}</td>
            <td class="text-xs-left">{{ props.item.answer | ellipseText(120) }}</td>
            <td class="text-xs-left">
              <v-layout row>
                <v-flex xs5 sm5>
                  <v-btn @click.prevent="goto('/admin/settings/tutorials/tutorial-new?mode=edit&id=' + props.item.id)" icon class="blue--text">
                    <v-icon medium>edit</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex xs5 sm5>
                  <v-btn @click="selectedItem = props.item; deleteDialog = true" icon class="red--text">
                    <v-icon>delete_forever</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Delete Question</v-card-title>
        <v-card-text>Are you sure you want to delete this question <b>{{selectedItem.question}}</b></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteDialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteTutorial">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import stripTags from 'striptags'
import Sortable from 'sortablejs'
export default {
  data () {
    return {
      headers: [
        {
          text: 'Reorder',
          sortable: false
          // align: 'left'
        },
        {
          text: 'Question',
          align: 'left',
          sortable: false,
          value: 'question'
        },
        {
          text: 'Answer',
          align: 'left',
          sortable: false,
          value: 'answer'
        },
        {
          text: 'Actions',
          sortable: false,
          align: 'left'
        }
      ],
      itemKeys: new WeakMap(),
      currentItemKey: 0,
      deleteDialog: false,
      selectedItem: {},
      items: [],
      sortable: null
    }
  },
  filters: {
    ellipseText (html = '', limit) {
      const text = stripTags(html, [], '\n')
      if (text.length < limit) return text
      const stripped = text.slice(0, limit - 1)
      return `${stripped}...`
    }
  },
  computed: {
    tutorials () {
      return this.$store.getters.tutorials.sort((a, b) => a.order - b.order)
    }
  },
  methods: {
    goto (link) {
      this.$router.push(link)
    },
    deleteTutorial () {
      return this.$store.dispatch('deleteTutorial', this.selectedItem).then(() => {
        this.deleteDialog = false
        this.reOrder(this.tutorials)
      })
    },
    dragReorder ({oldIndex, newIndex}) {
      const list = Array.from(this.tutorials)
      const movedItem = list.splice(oldIndex, 1)[0]
      list.splice(newIndex, 0, movedItem)
      this.reOrder(list)
    },
    itemKey (item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey)
      return this.itemKeys.get(item)
    },
    reOrder (list) {
      const ordered = list.map((faq, index) => {
        const data = { ...faq, order: index + 1 }
        return this.$firebase.database().ref(`tutorials/${data.id}`).set(data)
      })
      return Promise.all(ordered).then(res => {
        console.log('ordered done')
      })
    }
  },
  created () {
    this.$store.dispatch('getTutorials')
  },
  mounted () {
    this.sortable = new Sortable(
      this.$refs.faqTable.$el.getElementsByTagName('tbody')[0],
      {
        draggable: '.sortableRow',
        handle: '.sortHandle',
        onEnd: this.dragReorder
      }
    )

    const payload = {
      meta: {
        h1: 'Admin Tutorials',
        title: 'Admin Tutorials - Manage Tutorials',
        requiresAuth: true
      }
    }
    document.title = payload.meta.title
    this.$store.commit('setHeaderInfo', payload)
  }
}
</script>
<style scoped>
  #right {
    float: right !important;
  }
</style>



// WEBPACK FOOTER //
// TutorialTable.vue?49ed971c